module.exports = __webpack_public_path__ + "static/media/success.bdea1e96.svg";


//////////////////
// WEBPACK FOOTER
// ./src/atoms/Success/success.svg
// module id = 972
// module chunks = 0